import envConfig from '@acre/config'

import createAxiosInstance from '../utils/createAxiosInstance'

const axiosInstance = createAxiosInstance({
  baseURL: envConfig.ORY_KRATOS_URL,
})

export default axiosInstance
